/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'star-empty': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M36.906 21h-9.438l-2.922-9h-.031l-2.939 9H12l7.757 5.455-2.913 8.862-.031.002 7.68-5.565 7.679 5.508-2.909-8.85L36.906 21zm-12.418 6.278l-3.83 2.77 1.456-4.368L18.242 23h4.785l1.498-4.588L26.015 23h4.683l-3.79 2.639 1.472 4.476-3.892-2.837z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/star-empty.js